export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-10">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
              移动观影 · 随时随地
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md">
              妖精视频适配全平台设备，无论您使用手机、平板还是电脑，都能获得一致的流畅观影体验。
              各合作平台均提供独立移动端应用，直接通过本平台入口即可跳转观看。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-4 py-2.5 rounded-full bg-foreground-900 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-apple-fill"></i>
                iOS 版
              </div>
              <div className="flex items-center gap-2 px-4 py-2.5 rounded-full bg-accent-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-accent-600 transition-colors">
                <i className="ri-android-fill"></i>
                Android 版
              </div>
              <div className="flex items-center gap-2 px-4 py-2.5 rounded-full border-2 border-background-200 text-foreground-600 text-sm font-medium whitespace-nowrap cursor-pointer hover:border-primary-300 hover:text-primary-500 transition-colors">
                <i className="ri-computer-line"></i>
                网页版
              </div>
            </div>
          </div>
          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-[340px] aspect-[3/4] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20clean%20video%20streaming%20app%20interface%20with%20fruit%20themed%20color%20accents%20in%20coral%20and%20green%20tones%2C%20movie%20thumbnail%20grid%20layout%20with%20soft%20warm%20background%2C%20minimalist%20UI%20design%20with%20rounded%20cards%2C%20editorial%20quality%20product%20mockup%2C%20clean%20flat%20design%20style&width=680&height=900&seq=app-mockup-10&orientation=portrait"
                alt="妖精视频移动端观影界面展示"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}